import { render, staticRenderFns } from "./JiesuandanRight.vue?vue&type=template&id=2c02bd36&scoped=true"
import script from "./JiesuandanRight.vue?vue&type=script&lang=js"
export * from "./JiesuandanRight.vue?vue&type=script&lang=js"
import style0 from "./JiesuandanRight.vue?vue&type=style&index=0&id=2c02bd36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c02bd36",
  null
  
)

export default component.exports